import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { ISelectOption } from '../ISelectOption';
import { IAgent } from '../../../utils/types/IAgent';

interface AgentSelectProps {
    agents: IAgent[];
    isAgentsLoading: boolean;
    setSelectedItemId: (id: number | null) => void;
    selectedItemId: number | null;
    isDisabled?: boolean | null;
}

const AgentSelect: React.FC<AgentSelectProps> = ({ agents, isAgentsLoading, setSelectedItemId, selectedItemId, isDisabled }) => {
    const options: ISelectOption[] = agents.map((agent) => ({
        value: agent.id.toString(),
        label: agent.nom ?? '',
    }));

    const isGhost = selectedItemId !== null && !agents.some((agent) => agent.id === selectedItemId);
    const selectedOption = options.find((option) => parseInt(option.value) === selectedItemId) || (selectedItemId !== null ? { value: selectedItemId.toString(), label: '⚠️ Introuvable' } : null);

    const handleChange = (selectedOption: ISelectOption | null) => {
        setSelectedItemId(selectedOption ? parseInt(selectedOption.value) : null);
    };

    const customStyles: StylesConfig<ISelectOption, false> = {
        control: (provided) => ({
            ...provided,
            width: 'auto',
            minWidth: '150px',
            maxWidth: '100%',
        }),
        singleValue: (provided) => ({
            ...provided,
            whiteSpace: 'nowrap',
            color: isGhost ? 'red' : provided.color,
        }),
        menu: (provided) => ({
            ...provided,
            width: 'auto',
            minWidth: '150px',
        }),
        option: (provided) => ({
            ...provided,
            whiteSpace: 'nowrap',
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,
        }),
    };

    // useEffect(() => {
    //     if (selectedItemId !== null && !agents.some((agent) => agent.id === selectedItemId)) {
    //         setSelectedItemId(null);
    //     }
    // }, [agents, selectedItemId, setSelectedItemId]);

    return <Select id="autoSizingSelect" value={selectedOption} options={options} onChange={handleChange} placeholder={isAgentsLoading ? 'Chargement ...' : '--- Agent'} isLoading={isAgentsLoading} isClearable isSearchable noOptionsMessage={() => 'Aucun agent'} styles={customStyles} classNamePrefix="react-select" menuPortalTarget={document.body} isDisabled={isDisabled ?? false} />;
};

export default AgentSelect;
